

let _ = require('../_.js');
let $ = jQuery;

// Agree to TOC and register for bidding module.

// - Shows the accept TOC form.
// - Checks to see if the user needs to agree to new TOC, and in that case:
// - shows updated toc form

// New regiustration
let scroll_terms_state = false;
let scroll_terms_callback = null;
let $form_new_registration_toc;

// Updated TOC
let scroll_terms_updated_state = false;
let scroll_terms_updated_callback = null;
let $form_toc_updated;

// Constants
let rtfm_error_message = "You must scroll down, and accept the Terms and Conditions to continue.";


_.AuctionUI_Auction_Registration = class AuctionUI_Auction_Registration {

    static async init() {

        $form_new_registration_toc = $("#auctioncast-register-form");
        $form_toc_updated = $("#auctioncast-register-form-updated");

        this.init_ui();

        try {
            let property = await _.ac_state.auction.property.fetch_private();
            property.subscribe(true, _.AuctionUI_Auction_Registration.validate_toc_is_current);
        } catch (e) {
            console.error("Error subscribing to property for automatic TOC updates");
            console.error(e);
        }

    }

    static init_ui() {

        // Track the scroll state of terms when we should it for reigstering
        _.on_ui_update_once("#ac-modal-register-terms", function () {
            // Track scrolled into finished position event
            $(this).scrolled_to_end(function () {
                if (!scroll_terms_state) {
                    scroll_terms_state = true;
                    try {
                        if (scroll_terms_callback) {
                            scroll_terms_callback();
                        }
                    } catch (e) {
                        _.shouldnt_happen();
                    }
                }
            })
        });

        // Refactor: This should just be a static function on this class
        _.ac_registeration_modal = async function () {
            _.reset_form_errors($form_new_registration_toc);

            $("#user_accepted_terms_register").attr('disabled', 'disabled');
            $("#auctioncast-register-form-submit").removeClass('btn-success').addClass('btn-secondary');

            // Show modal. 
            (await $("#ac-modal-register").modal_show()).on_close(function () {
                // Have it kill the scroll_terms_callback when it closes.
                scroll_terms_callback = null;
            });

            // Uncheck the checkbox
            $("#user_accepted_terms_register").prop('checked', false);

            // Load terms of service.
            $("#ac-modal-register-terms").empty();

            await _.sleep(100);

            let terms_and_conditions = await (await _.ac_state.auction.property.fetch()).terms_and_conditions.fetch();

            // Loaded, set up environment
            scroll_terms_state = false;
            $("#ac-modal-register-terms").html(terms_and_conditions.terms);
            $("#terms_and_conditions_id").val(terms_and_conditions.id);

            await _.sleep(500);

            // Setup response to scrolled into finished position event.
            scroll_terms_callback = function () {
                $("#user_accepted_terms_register").attr('disabled', false);
                $("#auctioncast-register-form-submit").addClass('btn-success').removeClass('btn-secondary');
                scroll_terms_state = true;
            }

            // Check to see if scrolled to end.
            $("#ac-modal-register-terms").scrolled_to_end(scroll_terms_callback);
        }

        // Register to bid button handler
        _.on_ui_update_once('.ac-component-bid-register-auction', function () {
            $(this).click(async function () {
                _.ac_registeration_modal();
            });
        });

        // NEW REGISTRATION FORM HANDLERS

        // Alert for needing to accept terms of service to continue - terms checkbox
        _.on_ui_update_once('#user_accepted_terms_register_container', function () {
            $(this).click(function () {
                if (!scroll_terms_state) {
                    _.apply_form_errors($form_new_registration_toc, { "user_accepted_terms": rtfm_error_message })
                } else {
                    _.reset_form_errors($form_new_registration_toc);
                }
            });
        });

        // Handle for submit registration button
        _.on_ui_update_once('#auctioncast-register-form', function () {
            $(this).submit(async function (e) {
                e.preventDefault();
                _.AuctionUI_Auction_Registration.handle_register_nextstep();
            });
        });

        // UPDATED TOC FORM HANDLERS
        _.on_ui_update_once('.user_accepted_terms_updated_register_container', function () {
            $(this).click(function () {
                if (!scroll_terms_updated_state) {
                    _.apply_form_errors($form_toc_updated, { "user_accepted_terms": rtfm_error_message })
                } else {
                    _.reset_form_errors($form_toc_updated);
                }
            });
        });

        // Handle for submit registration button
        _.on_ui_update_once('#auctioncast-register-form-updated', function () {
            $(this).submit(async function (e) {
                e.preventDefault();
                _.AuctionUI_Auction_Registration.handle_updated_toc_submit();
            });
        });

    }

    static async handle_register_nextstep() {
        if (!scroll_terms_state) {
            _.apply_form_errors($form_new_registration_toc, { "user_accepted_terms": rtfm_error_message })
        } else if (!$("#user_accepted_terms_register").is(":checked")) {
            _.apply_form_errors($form_new_registration_toc, { "user_accepted_terms": "You must agree to the Terms and Conditions to continue." })
        } else {
            _.reset_form_errors($form_new_registration_toc);
            let formValues = _.serialize_form($form_new_registration_toc);
            formValues.auction_id = _.AuctionUI.auction_id();
            formValues.terms_and_conditions_id = $("#terms_and_conditions_id").val();

            // Store this somewhere while we present the proof of funds upload form.
            window._register_form_values_tmp = formValues;

            _.Modal.hide();
            _.AuctionUI_Auction_Registration.proof_of_funds_modal();
        }
    }

    static async proof_of_funds_modal() {

        let property = await _.ac_state.auction.property.fetch();
        let $uploader = $("#ac-modal-register-proof-of-funds-terms-file-upload-input");

        $(".ac-modal-register-proof-of-funds-auctionname-header").text(property.title);

        $("#ac-modal-register-proof-of-funds-modal").modal_show();

        if (!_.AuctionUI_Auction_Registration.sealed_bid_modal_ui_init) {
            _.AuctionUI_Auction_Registration.sealed_bid_modal_ui_init = true;

            $uploader.droppable();

            $(".ac-modal-register-proof-of-funds-step1-next").on('click', async function () {
                if (!$uploader.droppable_file_is_dropped()) {
                    if (!(await _.Modal.confirm("You did not provide a lender / proof of funds document.\n\nContinue anyway?\n\n"))) {
                        _.AuctionUI_Auction_Registration.proof_of_funds_modal();
                        return;
                    }
                }
                _.AuctionUI_Auction_Registration.handle_register_submit();
            });

            $(".ac-modal-register-proof-of-funds-step1-skip").on('click', async function () {
                _.AuctionUI_Auction_Registration.handle_register_submit();
            });
        }

        $uploader.droppable_reset();

    }

    static async handle_register_submit() {

        let $uploader = $("#ac-modal-register-proof-of-funds-terms-file-upload-input");

        let upload_key = null;

        if ($uploader.droppable_file_is_dropped()) {
            if ($uploader.droppable_file_is_uploading()) {
                _.Modal.unclosable("Please wait while the file uploads...");
                upload_key = await $uploader.droppable_upload_get_response();
                _.Modal.hide();
            } else {
                upload_key = await $uploader.droppable_upload_get_response();
            }
            if (typeof (upload_key) != 'string' || upload_key.error) {
                if (upload_key && upload_key.error) {
                    await _.Modal.alert(upload_key.error);
                } else {
                    await _.Modal.alert("There was an issue uploading your file.\n\nPlease try to upload the file again.");
                }
                _.AuctionUI_Auction_Registration.proof_of_funds_modal();
                return;
            }

            window._register_form_values_tmp.upload_key = upload_key;
        }

        try {
            _.Modal.hide();
            _.Modal.unclosable();

            let formValues = window._register_form_values_tmp;

            await _.backend_ajax('auctions', 'register', formValues, $form_new_registration_toc);
            await _.AuctionUI_Session.refresh();
            await _.data_sync();

            let current_round_pub = await _.AuctionUI.get_current_round();
            let current_round = current_round_pub ? await current_round_pub.private() : null;

            _.Modal.hide();

            // ??
            if (current_round && (await _.Lib_Auction_Bids.can_bid(current_round))) {
                _.AuctionUI_Bids.do_custom_bid();
            }

            // Server now sends notification that registration is received and pending approval

        } catch (error) {
            _.apply_form_errors($form_new_registration_toc, error);
            $("#ac-modal-register").show();
        }
    }

    // Checks to see if the user is logged in, and registration active, but the current terms and conditions have
    // changed from what was previously agreed upon.  In this case, it shows a modal window stating this.
    // The check happens on login, on page load, on realtime update of current property record, and before bidding.
    // The user can close the window and it won't come up again until page reload, or attempt to bid.
    // Returns true if current toc is valid or user agrees to updated toc.
    static __validate_toc_is_current_has_nagged = false;
    static async validate_toc_is_current(force = false) {
        try {
            let registration = await _.AuctionUI_Session.get_registration();
            let property = await _.ac_state.auction.property.fetch();

            if (!registration || !registration.id) {
                return false;
            }

            // Debug logging for AuctionRegistration TOC check
            console.log('AuctionRegistration TOC Check:', {
                'registration_id': registration.id,
                'registration_approved': registration.approved,
                'registration_toc_id': registration.terms_and_conditions_id,
                'property_toc_id': property.terms_and_conditions_id,
                'toc_ids_match': registration.terms_and_conditions_id == property.terms_and_conditions_id,
                'will_show_modal': registration.approved && registration.terms_and_conditions_id != property.terms_and_conditions_id
            });

            if (registration && registration.approved && registration.terms_and_conditions_id == property.terms_and_conditions_id) {
                return true;
            }

            // Fixed: was comparing user_accepted_terms (boolean) with terms_and_conditions_id (integer)
            // Should compare registration.terms_and_conditions_id with property.terms_and_conditions_id
            if (registration && registration.approved && registration.terms_and_conditions_id != property.terms_and_conditions_id) {
                if (!_.AuctionUI_Auction_Registration.__validate_toc_is_current_has_nagged || force) {
                    _.AuctionUI_Auction_Registration.__validate_toc_is_current_has_nagged = true;
                    console.log('Showing AuctionRegistration TOC modal');
                    return _.AuctionUI_Auction_Registration.request_updated_toc_agreement()
                } else {
                    return false;
                }
            }

            return false;
        } catch (e) {
            console.error("Error checking for automatic TOC updates");
            console.error(e);
        }
    }

    static __toc_current_check_promise_resolve;
    static __toc_current_check_promise_reject;

    // Shows the form prompting the user to accept the updated toc.  Returns true if they agreed.
    static async request_updated_toc_agreement() {
        if ($("#ac-modal-register-updated").is(":visible")) {
            return;
        }

        _.reset_form_errors($form_toc_updated);

        $("#user_accepted_terms_updated_register").attr('disabled', 'disabled');
        $("#auctioncast-register-updated-form-submit").removeClass('btn-success').addClass('btn-secondary');

        // Uncheck the checkbox
        $("#user_accepted_terms_updated_register").prop('checked', false);

        // Load terms of service.
        $("#ac-modal-register-updated-terms").empty();

        let property = await _.ac_state.auction.property.fetch();

        await _.sleep(100);

        // Set title in body text on the modal
        $("#ac-modal-register-updated-auctionname").text(property.title);

        // Get the TOC record
        let terms_and_conditions = await property.terms_and_conditions.fetch();

        // Loaded, set up environment
        scroll_terms_updated_state = false;
        $("#ac-modal-register-updated-terms").html(terms_and_conditions.terms);
        $("#terms_and_conditions_id-updated").val(terms_and_conditions.id);

        await _.sleep(500);

        // Setup response to scrolled into finished position event.
        scroll_terms_updated_callback = function () {
            $("#user_accepted_terms_updated_register").attr('disabled', false);
            $("#auctioncast-register-updated-form-submit").addClass('btn-success').removeClass('btn-secondary');
            scroll_terms_updated_state = true;
        }

        // Check to see if scrolled to end.
        $("#ac-modal-register-updated-terms").scrolled_to_end(scroll_terms_updated_callback);

        // Setup submit handlers
        let has_resolved = false;

        return new Promise(async function (_resolve, _reject) {
            _.AuctionUI_Auction_Registration.__toc_current_check_promise_resolve = function (data) {
                if (!has_resolved) {
                    has_resolved = true;
                    _resolve(data);
                }
            }

            _.AuctionUI_Auction_Registration.__toc_current_check_promise_reject = function (data) {
                if (!has_resolved) {
                    has_resolved = true;
                    _reject(data);
                }
            }

            // Make this modal persistent - critical for legal compliance
            // This prevents the notification system or session refresh from dismissing the modal
            _.Modal.set_unhidable();

            // Show modal.
            let modal_instance = await $("#ac-modal-register-updated").modal_show();

            // Override the default modal-close behavior to call close_unhidable()
            // This allows the close/cancel buttons to work while preventing other code from dismissing
            $("#ac-modal-register-updated .modal-close").off('click').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _.Modal.close_unhidable();
            });

            // Register a shutdown handler
            modal_instance.on_close(function () {
                // Have it kill the scroll_terms_callback when it closes.
                scroll_terms_updated_callback = null;
                _.AuctionUI_Auction_Registration.__toc_current_check_promise_reject();
            });

            // Now we wait to see if they press the submit button or close the modal.
        });
    }

    static async handle_updated_toc_submit() {
        if (!scroll_terms_updated_state) {
            _.apply_form_errors($form_toc_updated, { "user_accepted_terms": rtfm_error_message })
        } else if (!$("#user_accepted_terms_updated_register").is(":checked")) {
            _.apply_form_errors($form_toc_updated, { "user_accepted_terms": "You must agree to the Terms and Conditions to continue." })
        } else {
            _.reset_form_errors($form_toc_updated);
            let formValues = _.serialize_form($form_toc_updated);
            formValues.auction_id = _.AuctionUI.auction_id();
            formValues.terms_and_conditions_id = $("#terms_and_conditions_id-updated").val();

            try {

                await _.backend_ajax('auctions', 'update_toc_agreement', formValues, $form_toc_updated);

                // Close the modal first, before refreshing session
                await _.Modal.close_unhidable();

                await _.AuctionUI_Session.refresh();

                // This calls the resolve() promise set up in the function above
                _.AuctionUI_Auction_Registration.__toc_current_check_promise_resolve();

            } catch (error) {
                _.apply_form_errors($form_toc_updated, error);
                $("#ac-modal-register-updated").show();
            }
        }
    }



    // let scroll_terms_updated_state = false;
    // let scroll_terms_updated_callback = null;
}